import { Injectable } from '@angular/core';
import { Router, CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';


@Injectable()
export class AuthGuardService implements CanActivate {

    constructor(private auth: AuthenticationService
        , private router: Router
        , private toastr: ToastrService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return new Promise(resolve => {
            if(this.auth.isAuthenticated()){
                resolve(true); 
            } else {
                this.toastr.error("Please login...", "Unauthorized");
                //add redirect url to path so we can go to where the user wants to go
                //this.router.navigate(['/auth'],{queryParams:{'redirectURL':route.url[0].path}});   
                if (route.url.length > 0) {
                    localStorage.setItem('redirectURL',route.url[0].path)         
                }   
                let url = environment.awslogin;
                //this.router.navigateByUrl("/auth")
                // localStorage.setItem('redirectURL',this.route.url[0].path)
                window.location.assign(url);
                resolve(false);
            }
        });
    }
}
